import { createDeleteIntentHighlightEffect } from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export function createDeleteIntentHighlightEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.DELETE_INTENT_HIGHLIGHT_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE && ctx.permissions.canEditContent,
    factory: () => createDeleteIntentHighlightEffect(),
  };
}
